
import React, { Component } from "react";
import NumberCard from "../../../components/NumberCard";
import { delay } from "../../../../../shared/utils";
import { CircularProgress } from "@mui/material";

export default class NumberCardStat extends Component {

   state = {
      number: 0,
      loading: false,
   }

   fetchData = async (retryIn=1000) => {
      try {

         this.setState({ loading: true });
         const number = await this.props.getNumber();
         this.setState({ number, loading: false });

      } catch (error) {
         await delay(retryIn);
         this.fetchData(retryIn * 2);
      }
   }

   componentDidMount() {
      this.fetchData();
   }

   render() {
      return <div className="relative">
         <NumberCard
            title={this.props.title}
            value={this.state.number}
            icon={this.props.icon}
         />
         {
            this.state.loading && <div className="absolute inset-0 bg-white border-[1px] flex items-center justify-center rounded-lg">
               <CircularProgress
                  thickness={5}
                  size={20}
               />
            </div>
         }
      </div>
   }
}